import { formatDateNonlocalised } from '@web-platform/shared-universal-utils-frontend-localisation';
import { isValid } from 'date-fns/isValid';
import { parseISO } from 'date-fns/parseISO';
import { set as setDate } from 'date-fns/set';

import { nonNullishOrThrow } from './assertNonNullish';

import type { SkyscannerCommonV1Datetime } from '@skyscanner-internal/sonar-web-http-client';

type LocalDateTime = SkyscannerCommonV1Datetime.LocalDateTime;

export const sonarLocalDateTimeToISOString = (localDateTime: LocalDateTime): string => {
  const date = setDate(new Date(), {
    year: nonNullishOrThrow(localDateTime.year, 'localDateTime.year'),
    date: nonNullishOrThrow(localDateTime.day, 'localDateTime.day'),
    month: nonNullishOrThrow(localDateTime.month, 'localDateTime.month') - 1,
    hours: nonNullishOrThrow(localDateTime.hour, 'localDateTime.hour'),
    minutes: nonNullishOrThrow(localDateTime.minute, 'localDateTime.minute'),
    seconds: 0,
    milliseconds: 0,
  });
  return formatDateNonlocalised(date, "yyyy-MM-dd'T'HH:mm:ss");
};

export const mapISOStringToSonarLocalDate = (dateString: string): LocalDateTime => {
  const date = parseISO(dateString);
  if (!isValid(date)) {
    throw new Error(`Invalid date string: ${dateString}`);
  }
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
};
